// Experiment configuration, add experiments here
// Note: Allocation percentages must sum to 100
export const EXPERIMENTS = {
  pricing_order: {
    variants: ['original_order', 'reversed_order'],
    allocation: { original_order: 50, reversed_order: 50 },
  },
  mid_flow_mobile: {
    variants: ['show_mobile', 'skip_mobile'],
    allocation: { show_mobile: 50, skip_mobile: 50 },
  },
  content_gallery: {
    variants: ['show_gallery', 'skip_gallery'],
    allocation: { show_gallery: 10, skip_gallery: 90 },
  },
  onboarding_add_more_images: {
    variants: ['control', 'add_more_images'],
    allocation: { control: 50, add_more_images: 50 },
  },
  integrations_onboarding: {
    variants: ['hide', 'v2'],
    allocation: { hide: 90, v2: 10 },
  },
  mobile_calendar_access: {
    variants: ['allow', 'deny'],
    allocation: { allow: 50, deny: 50 },
  },
  blaze_explainer: {
    variants: ['show_explainer', 'skip_explainer'],
    allocation: { show_explainer: 50, skip_explainer: 50 },
  },
  growth_graph: {
    variants: ['control', 'test'],
    allocation: { control: 80, test: 20 },
  },
  autopilot_campaigns: {
    variants: ['show', 'hide'],
    allocation: { show: 10, hide: 90 },
  },
  starter_or_pioneer: {
    variants: ['pioneer', 'starter'],
    allocation: { pioneer: 50, starter: 50 },
  },
  // example
  // feature_flag_name: {
  //   variants: ['control', 'variant_a', 'variant_b', 'variant_c'],
  //   allocation: { control: 25, variant_a: 25, variant_b: 25, variant_c: 25 },
  // },
} as const

export type ExperimentId = keyof typeof EXPERIMENTS
